import React from 'react';

/**
 * Граница ошибок вокруг всего приложения.
 *
 * React 18 при необработанной ошибке отрисовки снимает всё дерево целиком: одна
 * колода с языком, которого не знал список, оставляла пустой белый экран и ни
 * слова в интерфейсе. Теперь на этом месте остаётся сообщение и кнопка
 * перезагрузки, а причина уходит в консоль — экран перестаёт быть немым.
 *
 * Намеренно без antd, i18next и redux: обёртка должна пережить поломку в любом
 * из них, поэтому здесь только React и разметка.
 */
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { failed: false, message: '' };
    }

    static getDerivedStateFromError(error) {
        return { failed: true, message: error && error.message ? error.message : String(error) };
    }

    componentDidCatch(error, info) {
        console.error('Приложение остановилось на ошибке отрисовки', error, info);
    }

    render() {
        if (!this.state.failed) {
            return this.props.children;
        }
        return (
            <div
                style={{
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '12px',
                    padding: '24px',
                    textAlign: 'center',
                    fontFamily: 'system-ui, -apple-system, Arial, sans-serif',
                    color: '#3f3f3f',
                }}
            >
                <h1 style={{ fontSize: '20px', margin: 0 }}>Something went wrong</h1>
                <p style={{ margin: 0, color: '#808080', maxWidth: '480px' }}>
                    The page could not be displayed. Reloading usually helps; if it does not,
                    the details below say what failed.
                </p>
                <code style={{ color: '#8B0000', wordBreak: 'break-word', maxWidth: '480px' }}>
                    {this.state.message}
                </code>
                <button
                    type="button"
                    onClick={() => window.location.reload()}
                    style={{
                        marginTop: '8px',
                        padding: '8px 20px',
                        border: '1px solid #027b83',
                        borderRadius: '6px',
                        background: '#027b83',
                        color: '#ffffff',
                        cursor: 'pointer',
                    }}
                >
                    Reload
                </button>
            </div>
        );
    }
}

export default ErrorBoundary;
